// --------------------------------------------------------------------------
// newsletter.js
// --------------------------------------------------------------------------
//
// --------------------------------------------------------------------------

EC.newsletter = function () {

  'use strict';

  function init() {
    const newsletterForm = document.querySelector('.js-newsletter-form > .fui-i > .fui-form');

    if (newsletterForm) {
      const whatsOnCheckbox = newsletterForm.querySelector('input[data-fui-id="newsletter-ticketAlerts-4b0969c805"]');

      if (whatsOnCheckbox) {
        whatsOnCheckbox.addEventListener('change', function () {
          const value = whatsOnCheckbox.checked ? '4b0969c805' : 'd22a0b85c0';
          whatsOnCheckbox.setAttribute('value', value);
        });
      }
    }

  }

  return {
    init: init
  };

}();
